import { render, staticRenderFns } from "./connected-call.vue?vue&type=template&id=6036fba6&scoped=true&"
import script from "./connected-call.vue?vue&type=script&lang=js&"
export * from "./connected-call.vue?vue&type=script&lang=js&"
import style0 from "./connected-call.vue?vue&type=style&index=0&id=6036fba6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6036fba6",
  null
  
)

export default component.exports